const STORAGE_KEY = '__ext_referrer';
const URL_STORAGE_KEY = '__landing_url';
const INTERNAL_DOMAINS = ['hirist.tech', 'iimjobs.com', 'hirist.com'];

const isInternal = (url: string): boolean => {
  try {
    const hostname = new URL(url).hostname;
    return INTERNAL_DOMAINS.some(d => hostname === d || hostname.endsWith(`.${d}`));
  } catch {
    return false;
  }
};

const endOfDayTimestamp = (): number => {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d.getTime();
};

export const getStoredReferrer = (): string => {
  if (typeof window === 'undefined') return '';

  const raw = localStorage.getItem(STORAGE_KEY);

  if (raw) {
    try {
      const {value, expiry} = JSON.parse(raw);
      if (Date.now() <= expiry) return value;
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  // Capture fresh referrer if external
  const referrer = document.referrer;
  if (referrer && !isInternal(referrer)) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({value: referrer, expiry: endOfDayTimestamp()})
    );
    return referrer;
  }

  return '';
};

export const getStoredLandingUrl = (): string => {
  if (typeof window === 'undefined') return '';

  const raw = localStorage.getItem(URL_STORAGE_KEY);

  if (raw) {
    try {
      const {value, expiry} = JSON.parse(raw);
      if (Date.now() <= expiry) return value;
      localStorage.removeItem(URL_STORAGE_KEY);
    } catch {
      localStorage.removeItem(URL_STORAGE_KEY);
    }
  }

  // Capture current URL on first call (landing page)
  const currentUrl = window.location.href;
  localStorage.setItem(
    URL_STORAGE_KEY,
    JSON.stringify({value: currentUrl, expiry: endOfDayTimestamp()})
  );
  return currentUrl;
};
